export default [{
  path: '/descricao-uc',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Descrição da UC',
      path: '',
      component: () => import('@/views/descricaoUc/Index.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Descrição da UC' }
        ]
      }
    }
  ]
}]